import * as React from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { getMe } from '../../shared/api/user';
import { Formik } from 'formik';
import { updateUser } from '../../shared/api/user';
import { inputLabelClasses } from "@mui/material/InputLabel";
import "./registration-details.css";

const style = {
    "& .MuiOutlinedInput-root": {
        "&.Mui-focused fieldset": {
            borderColor: "#CB2704"
        }
    }
}
const theme = createTheme();

export default function SignUp() {

    const [User, setUser] = useState([]);
    const navigate = useNavigate();
    const [err, seterr] = useState('');
    const init = async () => {
        let user = await getMe();
        setUser(user.data.user);
    }

    useEffect(() => {
        init();
    }, []);

    if (!User.email) {
        return <Box display="flex"
            justifyContent="center"
            alignItems="center">Loading</Box>
    }
    return (
        <ThemeProvider theme={theme}>
            <Container className='edit-prof-cnt' component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                    sx={{
                        marginTop: 12,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >

                    <Typography sx={{ mt: 2, mb: 2, fontWeight: '600' }} component="h1" variant="h5">
                        Form details
                    </Typography>
                    <Box sx={{ mt: 3 }}>
                        <Grid container spacing={2}>
                            <Formik initialValues={{ firstName: User.firstName, lastName: User.lastName, email: User.email, paypalEmail: User.paypalEmail, experience: User.experience, about: User.about, restaurantName: User.restaurantName }}
                                onSubmit={(values, { setSubmitting }) => {
                                    setTimeout(async () => {
                                        console.log(values)
                                        setSubmitting(false);
                                        let res = await updateUser(User._id, values);
                                        console.log(res)
                                        navigate("/dashboard");
                                    }, 400);
                                }}
                            >
                                {({ handleSubmit, handleChange, isSubmitting, enableReinitialize, values }) => (
                                    <form onSubmit={(e) => {
                                        e.preventDefault();
                                        handleSubmit();
                                    }}>
                                        <Grid sx={{ mb: 2 }} item xs={12}>
                                            <TextField
                                                sx={style}
                                                InputLabelProps={{
                                                    sx: {
                                                        [`&.${inputLabelClasses.shrink}`]: {
                                                            color: "#CB2704"
                                                        }
                                                    }
                                                }}
                                                fullWidth
                                                id="restaurantName"
                                                name='restaurantName'
                                                placeholder='Restaurant Name'
                                                value={values.restaurantName}
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                        <Grid sx={{ mb: 2 }} item xs={12}>
                                            <TextField
                                                sx={style}
                                                InputLabelProps={{
                                                    sx: {
                                                        [`&.${inputLabelClasses.shrink}`]: {
                                                            color: "#CB2704"
                                                        }
                                                    }
                                                }}
                                                fullWidth
                                                id="email"
                                                name="email"
                                                placeholder='Email'
                                                value={values.email}
                                                autoComplete="email"
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                        <Grid sx={{ mb: 2 }} item xs={12}>
                                            <TextField
                                                sx={style}
                                                InputLabelProps={{
                                                    sx: {
                                                        [`&.${inputLabelClasses.shrink}`]: {
                                                            color: "#CB2704"
                                                        }
                                                    }
                                                }}
                                                fullWidth
                                                id="paypalEmail"
                                                name='paypalEmail'
                                                placeholder='Paypal Email'
                                                value={values.paypalEmail}
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                        <Grid sx={{ mb: 2 }} item xs={12}>
                                            <TextField
                                                sx={style}
                                                InputLabelProps={{
                                                    sx: {
                                                        [`&.${inputLabelClasses.shrink}`]: {
                                                            color: "#CB2704"
                                                        }
                                                    }
                                                }}
                                                fullWidth
                                                id="about"
                                                name='about'
                                                placeholder='Description'
                                                value={values.about}
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                        <Grid sx={{ mb: 2 }} item xs={12}>
                                            <TextField
                                                sx={style}
                                                InputLabelProps={{
                                                    sx: {
                                                        [`&.${inputLabelClasses.shrink}`]: {
                                                            color: "#CB2704"
                                                        }
                                                    }
                                                }}
                                                fullWidth
                                                id="experience"
                                                name='experience'
                                                placeholder='Experience'
                                                value={values.experience}
                                                onChange={handleChange}
                                            />
                                        </Grid>

                                        <Grid sx={{ mb: 2 }} item xs={12}>
                                            <TextField
                                                sx={style}
                                                InputLabelProps={{
                                                    sx: {
                                                        [`&.${inputLabelClasses.shrink}`]: {
                                                            color: "#CB2704"
                                                        }
                                                    }
                                                }}
                                                fullWidth
                                                id="servicefee"
                                                name='servicefee'
                                                placeholder='Service fee'
                                                value={values.experience}
                                                onChange={handleChange}
                                            />
                                        </Grid>

                                        <Button
                                            type="submit" disabled={isSubmitting}
                                            fullWidth
                                            variant="contained"
                                            sx={{ mt: 2, mb: 2, background: '#CB2704', "&:hover": { background: "red" } }}
                                        >
                                            Submit
                                        </Button>
                                    </form>)}

                            </Formik>
                        </Grid>
                    </Box>
                </Box>
            </Container>
        </ThemeProvider>
    );
}